"use client";
import { kebabCase as E } from "./index.es7.js";
import a, { useState as c, useMemo as m, useEffect as h, useCallback as ee } from "react";
import M from "styled-components";
import { getCategoriesDefault as N, categoryOptionsFromDetails as te, toCategoriesString as ae, regionCodesFromRegionSelection as le, toExcelIndicatorData as ne, yearsFromRegionYearValues as re, chartDataForRegionsByYear as oe, toCategories as ie } from "./index.es4.js";
import se from "./index.es82.js";
import ce from "./index.es83.js";
import me from "./index.es84.js";
import de from "./index.es85.js";
import V from "./index.es86.js";
import "./index.es44.js";
import ue from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import "./index.es50.js";
import "./index.es51.js";
import b from "./index.es62.js";
import I from "./index.es16.js";
import ge from "./index.es30.js";
const O = (e, o, s) => {
  const d = {};
  return o?.explanation && o?.explanation?.content && (d["Om datagrunnlaget"] = o?.explanation), o?.about && o.about?.content && (d["Om indikatoren"] = o?.about), e === "distribution" && s && s?.content && (d["Om fordelingskurve"] = s), d;
}, fe = M.div`
  &.monitor-indicator-details--fullscreen {
    margin-left: calc(
      (4rem + ${b.containerWidths.medium} - 100vw) / 2
    );
    margin-right: calc(
      (4rem + ${b.containerWidths.medium} - 100vw) / 2
    );
  }
  .monitor-indicator-header {
    display: flex;
    h2 {
      padding-right: 1rem;
      margin-bottom: 2.5rem;
    }
  }
  ${b.mediaQueries["bl-handset-down"]} {
    .expander-container {
      display: none;
    }
  }

  .expander-container {
    min-width: 15rem;
    text-align: right;
    button {
      padding-right: 0;
    }
  }
`, pe = M.div`
  display: flex;
  & > * {
    margin-left: 1rem;
    ${b.mediaQueries["bl-handset-large-up"]} {
      &:first-child {
        margin-left: 0;
      }
    }
  }
  margin-bottom: 1.5rem;

  ${b.mediaQueries["bl-handset-down"]} {
    flex-direction: column;
    & > * {
      margin-bottom: 0.5rem;
    }
  }
`, je = ({
  indicator: e,
  distributionExplanation: o,
  regionSelection: s,
  monitorDetails: d,
  regionsData: f,
  fetchDistribution: B
}) => {
  const [D, Y] = c(!1), [n, y] = c(null), [p, k] = c([]), [l, j] = c("all-years"), [L, R] = c(O("all-years", e, o)), [$, S] = c(), [Q, T] = c(!1), u = m(
    () => d?.filter(
      (t) => t?.indicatorId === e?.indicatorApiId
    ),
    [d, e]
  ), [i, w] = c(
    N(u)
  ), [U, W] = c();
  h(() => {
    w(N(u));
  }, [u]);
  const _ = m(() => te(u), [u]), q = m(
    () => ae(i),
    [i]
  ), x = m(
    () => le(s),
    [s]
  ), v = m(
    () => i?.includes("antall") ? "Absolute" : "Proportional",
    [i]
  ), z = m(() => l === "distribution" ? "fordelingskurv" : n || "alle-aar", [n, l]), G = (t) => {
    t && W(t);
  };
  h(() => {
    let t = !1;
    return (async () => {
      let g;
      if (n && s?.primaryRegion && i?.length && (g = await B(
        s,
        e?.indicatorApiId,
        n,
        i
      )), !t && (S(g), !Q)) {
        const C = window.location.hash, F = C ? document.querySelector(C) : void 0;
        F && (F?.scrollIntoView({ behavior: "smooth" }), T(!0));
      }
    })(), () => {
      t = !0;
    };
  }, [s, e, n, i]);
  const r = m(() => d ? u?.filter((g) => g?.categories.length === i?.length && g?.categories.every((C) => i?.includes(C)) && g?.indicatorId === e?.indicatorApiId && x?.includes(g?.regionCode)) : [], [i, e, x, u]), H = m(
    () => ne(r, e, f),
    [r, e, f]
  ), K = ee(
    (t) => {
      y(t === "none" ? null : t);
    },
    [n]
  ), P = (t) => {
    j(t);
  }, J = (t) => {
    w(ie(t));
  };
  h(() => {
    R(
      O(l, e, o)
    );
  }, [e, o, l]), h(() => {
    if (r) {
      const t = re(r);
      k(t), !n && t?.length && y(t[t?.length - 1]);
    } else
      k([]);
  }, [r]), h(() => {
    l !== "all-years" && !n && y(p[p?.length - 1]);
  }, [l]);
  const X = l === "all-years" ? [{ value: "all-years", label: "Alle år vises" }] : [...p?.map((t) => ({ value: t, label: t }))], Z = [
    {
      value: "all-years",
      label: "Utvikling over tid",
      ariaLabel: "Visualisering av data. Data er også tilgjengelig i tabell"
    },
    {
      value: "single-year",
      label: "Enkeltår",
      ariaLabel: "Visualisering av data. Data er også tilgjengelig i tabell"
    },
    {
      value: "distribution",
      label: "Fordelingskurve",
      ariaLabel: "Visualisering av data. Data er også tilgjengelig i tabell"
    },
    {
      value: "table",
      label: "Tabell",
      ariaLabel: "Tabell visning av utvalgte data"
    }
  ], A = m(
    () => r ? oe(
      r,
      f,
      null,
      v
    ) : null,
    [r, f, v]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, u?.length > 0 && /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement(
    fe,
    {
      id: E(e?.title),
      className: `bl-tile bl-tile--flat scroll-anchor ${D ? "monitor-indicator-details--fullscreen" : ""}`
    },
    /* @__PURE__ */ a.createElement("div", { className: "bl-container bl-container--small monitor-indicator-header" }, /* @__PURE__ */ a.createElement("h2", { className: "bl-size-3" }, e?.title), /* @__PURE__ */ a.createElement("div", { className: "expander-container" }, /* @__PURE__ */ a.createElement(
      ue,
      {
        onClick: () => Y(!D),
        iconName: "expand",
        isSmall: !0,
        styleType: "tertiary"
      },
      D ? "Lukk Fullskjerm" : "Vis Fullskjerm"
    ))),
    !!r && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(pe, { className: "bl-container bl-container--small" }, /* @__PURE__ */ a.createElement(
      I,
      {
        name: `select-mode-for-${e?.indicatorApiId}`,
        label: "Velg visning",
        value: l,
        options: Z,
        onChange: P
      }
    ), /* @__PURE__ */ a.createElement(
      I,
      {
        label: "Velg enhet",
        name: `select-units-and-measured-entity-for-${e?.indicatorApiId}`,
        options: _,
        value: q,
        onChange: J
      }
    ), /* @__PURE__ */ a.createElement(
      I,
      {
        name: `select-year-for-${e?.indicatorApiId}`,
        label: "Velg år:",
        value: l === "all-years" ? "all-years" : n || p[p?.length - 1] || "",
        options: X,
        onChange: K
      }
    )), /* @__PURE__ */ a.createElement(
      V,
      {
        displayMode: l,
        indicator: e,
        regionsData: f,
        tableChartData: A,
        units: v,
        year: n || void 0,
        valuesByYear: r,
        indicatorDistribution: $
      }
    ), /* @__PURE__ */ a.createElement(me, null, /* @__PURE__ */ a.createElement(
      V,
      {
        displayMode: l,
        indicator: e,
        regionsData: f,
        tableChartData: A,
        units: v,
        year: n || void 0,
        valuesByYear: r,
        indicatorDistribution: $,
        isDownload: !0,
        onChartChange: G
      }
    ))),
    /* @__PURE__ */ a.createElement(
      ge,
      {
        key: `monitor-details-block-accordions-indicator-${e?.id}-mode-${l}`,
        contextKey: `monitor-details-block-accordions-indicator-${e?.id}-mode-${l}`,
        accordionsData: L,
        initiallyOpen: []
      }
    )
  ), /* @__PURE__ */ a.createElement(se, { className: "bl-m-t-2 bl-m-b-5" }, /* @__PURE__ */ a.createElement(
    ce,
    {
      chart: U,
      fileName: `${E(e?.title)}-${z}.png`
    }
  ), /* @__PURE__ */ a.createElement(
    de,
    {
      sheetData: H,
      fileName: `${E(e?.title)}.xlsx`
    }
  ))));
};
export {
  je as default
};
//# sourceMappingURL=index.es43.js.map
